import { z } from 'zod';
export const createExpenseItemSchema = z.object({
    eventId: z.string().uuid(),
    vendorCategoryId: z.string().uuid(),
    catalogItemId: z.string().uuid().optional(),
    itemName: z.string().max(255).optional(),
    vendorId: z.string().uuid().optional(),
    vendorName: z.string().max(255).optional(),
    // Optional — an expense line can be created without an amount and priced later.
    price: z.number().min(0).optional(),
    statusId: z.string().uuid().optional(),
    dueDate: z.string().optional(),
    comments: z.string().max(2000).optional(),
});
const CLIENT_APPROVAL_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];
export const updateExpenseItemSchema = z.object({
    vendorCategoryId: z.string().uuid().optional(),
    catalogItemId: z.string().uuid().nullable().optional(),
    itemName: z.string().max(255).nullable().optional(),
    vendorId: z.string().uuid().nullable().optional(),
    vendorName: z.string().max(255).nullable().optional(),
    price: z.number().min(0).optional(),
    statusId: z.string().uuid().optional(),
    dueDate: z.string().nullable().optional(),
    comments: z.string().max(2000).nullable().optional(),
    sortOrder: z.number().int().optional(),
    clientApproval: z.enum(CLIENT_APPROVAL_STATUSES).optional(),
});
export const createExpensePaymentSchema = z.object({
    amount: z.number().min(0),
    paymentMethodId: z.string().uuid(),
    paidAt: z.string().optional(),
    notes: z.string().max(2000).optional(),
});
export const createCatalogItemSchema = z.object({
    vendorCategoryId: z.string().uuid(),
    name: z.string().min(1).max(255),
    nameHe: z.string().max(255).optional(),
    sortOrder: z.number().int().optional(),
});
export const updateCatalogItemSchema = z.object({
    vendorCategoryId: z.string().uuid().optional(),
    name: z.string().min(1).max(255).optional(),
    nameHe: z.string().max(255).nullable().optional(),
    sortOrder: z.number().int().optional(),
    isActive: z.boolean().optional(),
});
// ─── Client Payments ────────────────────────────────────────────────────────
export const clientPaymentAllocationInputSchema = z.object({
    expenseItemId: z.string().uuid(),
    amount: z.number().min(0),
});
export const createClientPaymentSchema = z.object({
    eventId: z.string().uuid(),
    amount: z.number().min(0),
    paymentMethodId: z.string().uuid(),
    paidAt: z.string().optional(),
    reference: z.string().max(255).optional(),
    notes: z.string().max(2000).optional(),
    allocations: z.array(clientPaymentAllocationInputSchema).optional(),
});
export const updateClientPaymentSchema = z.object({
    amount: z.number().min(0).optional(),
    paymentMethodId: z.string().uuid().optional(),
    paidAt: z.string().optional(),
    reference: z.string().max(255).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
    allocations: z.array(clientPaymentAllocationInputSchema).optional(),
});
//# sourceMappingURL=expense.js.map